import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card data-table mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "body-function" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "svg-icon svg-icon-2" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "tbl" }
const _hoisted_8 = { style: {"display":"flex","align-items":"center","justify-content":"center"} }
const _hoisted_9 = {
  class: "col-12 py-2 pagination",
  style: {"justify-content":"end","margin-top":"0.5rem"}
}
const _hoisted_10 = {
  class: "card-body",
  style: {"border-top":"1px solid #eff2f5"},
  id: "menuTree"
}
const _hoisted_11 = {
  class: "d-flex align-items-center justify-content-between",
  style: {"margin-bottom":"16px"}
}
const _hoisted_12 = { style: {"padding-left":"24px","padding-top":"12px","padding-bottom":"4px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_RoleFilter = _resolveComponent("RoleFilter")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_KTModalRoles = _resolveComponent("KTModalRoles")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          disabled: _ctx.loading || !_ctx.handleCheckPerms('sys:role:add'),
          type: "primary",
          plain: "",
          onClick: _ctx.handleOpenAdd,
          size: _ctx.size,
          "data-bs-toggle": "modal",
          "data-bs-target": "#kt_modal_roles"
        }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createElementVNode("i", { class: "fa fa-plus" }, null, -1),
            _createTextVNode(" Thêm nhóm quyền", -1)
          ]))]),
          _: 1
        }, 8, ["disabled", "onClick", "size"])
      ]),
      _createElementVNode("button", {
        disabled: _ctx.loading,
        type: "button",
        class: "btn btn-sm btn-icon btn-color-primary btn-active-light-primary",
        "data-kt-menu-trigger": "click",
        "data-kt-menu-placement": "left-start",
        "data-kt-menu-flip": "top-end"
      }, [
        _createElementVNode("span", _hoisted_5, [
          _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen024.svg" })
        ])
      ], 8, _hoisted_4),
      _createVNode(_component_RoleFilter, {
        onSearch: _cache[0] || (_cache[0] = (val) => _ctx.handleFindPage(val))
      })
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: _ctx.tableData.content,
          fit: "",
          "header-row-class-name": "thead-light",
          height: "100%",
          size: _ctx.size,
          stripe: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "nMaNhomQuyen",
              label: "Mã nhóm quyền",
              "header-align": "center",
              width: "150",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              prop: "cTenNhomQuyen",
              label: "Tên nhóm quyền",
              "header-align": "center",
              "min-width": "180"
            }),
            _createVNode(_component_el_table_column, {
              prop: "cMoTa",
              label: "Mô tả",
              "header-align": "center",
              "min-width": "150"
            }),
            _createVNode(_component_el_table_column, {
              fixed: "right",
              label: "Hành động",
              "header-align": "center",
              width: "250",
              size: _ctx.size
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_el_button, {
                    size: _ctx.size,
                    type: "info",
                    disabled: scope.row.delFlag == 1,
                    title: "Xem",
                    plain: "",
                    onClick: ($event: any) => (_ctx.handleFindRoleMenu(scope.row))
                  }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createElementVNode("i", { class: "fa fa-eye" }, null, -1)
                    ]))]),
                    _: 1
                  }, 8, ["size", "disabled", "onClick"]),
                  _createVNode(_component_el_button, {
                    size: _ctx.size,
                    type: "primary",
                    disabled: scope.row.delFlag == 1 || !_ctx.handleCheckPerms('sys:role:edit'),
                    title: "Sửa",
                    plain: "",
                    onClick: ($event: any) => (_ctx.handleOpenEdit(scope.row)),
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#kt_modal_roles"
                  }, {
                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                      _createElementVNode("i", { class: "fa fa-wrench" }, null, -1)
                    ]))]),
                    _: 1
                  }, 8, ["size", "disabled", "onClick"]),
                  _createVNode(_component_el_button, {
                    size: _ctx.size,
                    title: "Xóa",
                    disabled: scope.row.delFlag == 1 || !_ctx.handleCheckPerms('sys:role:delete'),
                    type: "danger",
                    plain: "",
                    onClick: ($event: any) => (_ctx.handleDelete(scope.row))
                  }, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createElementVNode("i", { class: "fa fa-trash" }, null, -1)
                    ]))]),
                    _: 1
                  }, 8, ["size", "disabled", "onClick"])
                ])
              ]),
              _: 1
            }, 8, ["size"])
          ]),
          _: 1
        }, 8, ["data", "size"])), [
          [_directive_loading, _ctx.loading]
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_el_pagination, {
          disabled: _ctx.loading,
          "page-sizes": [5, 10, 20, 30, 50],
          layout: "total,sizes,prev,pager,next",
          small: true,
          "page-size": _ctx.pageRequest.pageSize,
          "current-page": _ctx.pageRequest.pageNum,
          onCurrentChange: _ctx.handleChangePage,
          onSizeChange: _ctx.handleChangeSize,
          total: _ctx.tableData.totalSize,
          size: _ctx.size
        }, null, 8, ["disabled", "page-size", "current-page", "onCurrentChange", "onSizeChange", "total", "size"])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("h1", null, "Phân quyền hệ thống: " + _toDisplayString(_ctx.selected?.cTenNhomQuyen), 1),
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.saveRoleMenu,
            disabled: !_ctx.handleCheckPerms('sys:role:edit'),
            size: _ctx.size
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createTextVNode("Lưu", -1)
            ]))]),
            _: 1
          }, 8, ["onClick", "disabled", "size"]),
          _createVNode(_component_el_button, {
            type: "warning",
            onClick: _ctx.resetRoleMenu,
            disabled: !_ctx.handleCheckPerms('sys:role:edit'),
            size: _ctx.size
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
              _createTextVNode("Thiết lập lại", -1)
            ]))]),
            _: 1
          }, 8, ["onClick", "disabled", "size"])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_el_checkbox, {
          size: _ctx.size,
          disabled: _ctx.selected?.nMaNhomQuyen == null,
          onChange: _ctx.handleCheckAll,
          modelValue: _ctx.checkAll,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.checkAll) = $event))
        }, {
          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
            _createElementVNode("b", null, "Chọn tất cả", -1)
          ]))]),
          _: 1
        }, 8, ["size", "disabled", "onChange", "modelValue"])
      ]),
      _withDirectives(_createVNode(_component_el_tree, {
        data: _ctx.menuTree,
        "show-checkbox": "",
        "node-key": "nMaChucNang",
        props: _ctx.treeProp,
        "check-strictly": _ctx.checkStrictly,
        style: {"width":"100%","padding-top":"10px","max-height":"500px","overflow":"auto"},
        "render-content": _ctx.renderContent,
        ref: "treeRef",
        "default-expand-all": "",
        "highlight-current": true
      }, null, 8, ["data", "props", "check-strictly", "render-content"]), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _createVNode(_component_KTModalRoles, {
      data: _ctx.dataForm,
      default: _ctx.defaultValues,
      type: _ctx.modalType,
      onFinish: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleFindPage(_ctx.pageRequest.columnFilters.cTenNhomQuyen.value)))
    }, null, 8, ["data", "default", "type"])
  ]))
}